import { create } from "zustand";

export enum WidgetState {
  collapsed,
  expanded,
  hidden,
}

export interface IUseTaskManagerStore {
  widgetState: WidgetState;
  setWidgetState: (state: WidgetState) => void;
  taskList: string[];
  setTaskList: (tasks: string) => void;
  updated: boolean;
  setUpdated: (updated: boolean) => void;
  completed: boolean;
  setCompleted: (completed: boolean) => void;
}

export const useTaskManagerStore = create<IUseTaskManagerStore>((set) => ({
  widgetState: WidgetState.hidden,
  setWidgetState: (state: WidgetState) => {
    set({ widgetState: state });
  },
  taskList: [],
  setTaskList: (task: string) => set((state) => ({ taskList: [...state.taskList, task] })),
  updated: false,
  setUpdated: (updated: boolean) => set({ updated }),
  completed: false,
  setCompleted: (completed: boolean) => set({ completed }),
}));
